import React, { forwardRef, ForwardedRef } from 'react';
import { Button } from '@tvg/fuse/button';
import { Modal } from '@tvg/fuse/modal';
import styles from './AddToBasketDialog.module.css';

type Props = {
  open: boolean;
  onClose: () => void;
  handleContinueShopping: (e: React.MouseEvent) => void;
  handleGoToBasket: (e: React.MouseEvent) => void;
};

const AddToBasketDialog = forwardRef((props: Props, ref: ForwardedRef<HTMLDivElement>) => {
  const { open, onClose, handleContinueShopping, handleGoToBasket } = props;

  return (
    <Modal
      name="add_to_basket_dialog"
      open={open}
      onClose={onClose}
      title="Item added to basket"
      titleTag="h2"
      dataTestId="add_to_basket_dialog"
      srLabelCloseButton="close add to basket dialog"
      zIndex="25"
    >
      <div className={styles.buttonContainer}>
        <Button
          className={styles.continueButton}
          variant="tertiary"
          onClick={handleContinueShopping}
          dataTestId="continue_shopping_button"
          size="large"
          fullWidth
        >
          Continue shopping
        </Button>
        <Button
          href="/basket.page"
          onClick={handleGoToBasket}
          dataTestId="go_to_basket_button"
          size="large"
          variant="primary"
          fullWidth
        >
          Go to basket
        </Button>
      </div>

      <div ref={ref} />
    </Modal>
  );
});

export default AddToBasketDialog;
